import { useEffect } from 'react';
import TaggingNameFiscalCodeCard from './nameFiscalCodeCard.tagging';
import { ICheckoutData } from '../../checkoutEnergy.models';
import { useEnergyCheckout } from '../../../energy.context';
import {
  CONSUMER_CMS_SHOPPING_CART,
  ErrorCodes,
  IGenericErrorCMS,
  IPersonalInfoCmsMobile,
  useCmsConfig,
  useGetFindCaller,
} from '@vfit/consumer/data-access';
import { API } from '@vfit/shared/data-access';
import {
  checkFiscalCode,
  getCmsValidationConfig,
  isFiscalCodeValid,
  organizeRetriveFiscalCodeMobile,
} from './nameFiscalCodeCard.utils';
import { NameFiscalCode } from '@vfit/consumer/components';
import { IPersonalDataObject } from '@vfit/shared/models';
import { Button } from '@vfit/shared/atoms';
import { ID_FLOWS } from '../../checkoutEnergy.constants';
import { ButtonWrapper } from './nameFiscalCodeCard.style';
import { getEnergyTagging } from '../../checkoutEnergy.utils';

const NameFiscalCodeCard = ({ handleGoNextSlide, handleOnFinish }: ICheckoutData) => {
  const { findCaller, product, owningData, setFindCaller, setCurrentStepKey, setOwningData } =
    useEnergyCheckout();
  const fiscalCode = owningData?.owningIndividual?.fiscalCode;
  const taggingEnergy = getEnergyTagging(product, 'personal data');
  const {
    data: findCallerResponse,
    isLoading: isLoadingFindCaller,
    isError: isErrorFindCaller,
    isSuccess: isSuccessFindCaller,
    refetch: getFindCaller,
    remove: removeFindCaller,
  } = useGetFindCaller(
    {
      fiscalCode: owningData.owningIndividual.fiscalCode,
    },
    {
      enabled: false,
    }
  );
  const dataFromCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PERSONAL_DATA_ENERGY
  ) as IPersonalInfoCmsMobile;
  const genericError = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_GENERIC_ERROR_ENERGY
  ) as IGenericErrorCMS;

  const nameFiscalCodeConfigCms = organizeRetriveFiscalCodeMobile(dataFromCms);

  const onChangeData = (data: IPersonalDataObject, isValid?: boolean) => {
    const { owningIndividual: owningIndividualData } = data;
    const {
      firstName: firstNameData,
      lastName: lastNameData,
      fiscalCode: fiscalCodeData,
    } = owningIndividualData;
    const { owningIndividual } = owningData;
    const { firstName, lastName, fiscalCode } = owningIndividual;
    const hasPersonalDataChanged =
      firstNameData !== firstName || lastNameData !== lastName || fiscalCodeData !== fiscalCode;

    if (owningData) {
      setOwningData({
        ...data,
      });
    }

    if (hasPersonalDataChanged) {
      if (!isValid) {
        setOwningData({
          ...data,
          isValid: false,
          isLogged: false,
        });
      }
    }
  };

  const goNext = () => {
    if (findCaller?.showOtp) {
      return handleGoNextSlide?.();
    }
    return handleOnFinish?.();
  };

  useEffect(() => {
    if (isErrorFindCaller) {
      const { errorCode } = checkFiscalCode(fiscalCode, 18, genericError?.genericerror);
      setOwningData({
        ...owningData,
        owningIndividual: {
          ...owningData.owningIndividual,
          fiscalCode:
            errorCode === ErrorCodes.FISCAL_CODE_ERROR
              ? owningData.owningIndividual.fiscalCode
              : '',
        },
        isValid: false,
      });
      removeFindCaller();
    } else if (isSuccessFindCaller) {
      const showOtp =
        !findCaller.isVerified &&
        !!(findCallerResponse.individualRef?.email || findCallerResponse.individualRef?.msisdn);
      setFindCaller({
        ...findCallerResponse,
        isVerified: false,
        showOtp,
      });
      removeFindCaller();
    }
  }, [isLoadingFindCaller, isErrorFindCaller, isSuccessFindCaller]);

  useEffect(() => {
    if (fiscalCode && isFiscalCodeValid(fiscalCode)) {
      const check = checkFiscalCode(fiscalCode);
      if (check?.fiscalCodeIsValid && !check?.isError) getFindCaller();
    }
  }, [fiscalCode]);

  useEffect(() => {
    setCurrentStepKey(ID_FLOWS.PERSONAL_INFO);
  }, []);

  return (
    <div>
      <TaggingNameFiscalCodeCard />
      <NameFiscalCode
        errorFiscalCode={
          isFiscalCodeValid(fiscalCode)
            ? checkFiscalCode(fiscalCode, 18, genericError?.genericerror)?.errorMessage?.message ||
              ''
            : ''
        }
        data={owningData}
        onChangeData={onChangeData}
        isLoading={isLoadingFindCaller}
        cmsConfig={nameFiscalCodeConfigCms}
        taggingData={{
          trackingProduct: taggingEnergy.trackingProduct,
          opts: taggingEnergy.opts,
        }}
        cmsValidationConfig={getCmsValidationConfig(dataFromCms)}
        children={
          <ButtonWrapper>
            <Button
              onClick={goNext}
              variant="primary"
              disabled={isLoadingFindCaller || !owningData?.isValid}
            >
              {product.buttons?.[0]?.label || 'Prosegui'}
            </Button>
          </ButtonWrapper>
        }
      />
    </div>
  );
};

export default NameFiscalCodeCard;
